import { JSXElement, Component, createSignal, createEffect } from 'solid-js';

export interface ImageProps {
  src: string;
  className?: string;
  errImg?: string;
  onClick?(): void;
}

const Image: Component<ImageProps> = (props): JSXElement => {
  let imgRef: HTMLImageElement | undefined;
  const [loading, setLoading] = createSignal<boolean>(true);
  const [error, setError] = createSignal<boolean>(false);

  // Reactive getters for props
  const getSrc = (): string => props.src || '';
  const getClassName = (): string => props.className || 'thumbnail micro';
  const getErrImg = (): string => props.errImg || '';

  // Reset loading and error state when src changes
  createEffect(() => {
    if (getSrc()) {
      setLoading(true);
      setError(false);
    }
  });

  const handleLoad = (): void => {
    setLoading(false);
  };

  const handleError = (): void => {
    setLoading(false);
    setError(true);
  };

  const handleClick = (event: MouseEvent): void => {
    // Emit custom event for React wrapper
    if (imgRef) {
      const customEvent = new CustomEvent('image-click', {
        detail: { originalEvent: event },
        bubbles: true,
      });
      imgRef.dispatchEvent(customEvent);
    }

    // Call onClick if provided
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <>
      {loading() && <modus-wc-loader variant="spinner" size="sm" />}
      <img
        ref={imgRef}
        src={!error() ? getSrc() : getErrImg()}
        class={loading() ? 'd-none' : getClassName()}
        onLoad={handleLoad}
        onError={handleError}
        onClick={handleClick}
      />
    </>
  );
};

export default Image;
